import { render, staticRenderFns } from "./MaterialsApps.vue?vue&type=template&id=2e810601"
import script from "./MaterialsApps.vue?vue&type=script&lang=js"
export * from "./MaterialsApps.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports